import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import useSequence from './use-sequence.hook';
import Label from './Label';
import {
  BaseWrapper,
  Layer,
  Skew,
  BaseElement,
  BaseMargin,
  SPRING_CONFIGS,
} from './bits';

function Multi() {
  const [stepIndex, step, handlers] = useSequence({
    mode: 'interactive',
  });

  const firstSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : -12}%)`,
    config: SPRING_CONFIGS[0],
  });

  const secondSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : 12}%)`,
    config: SPRING_CONFIGS[0],
  });

  return (
    <Wrapper {...handlers}>
      <Layer style={{ ...secondSpring }}>
        <Skew>
          <BaseElement />
          <NegativeMargin style={{ height: 75 }} />
        </Skew>
        <Label
          isVisible={stepIndex === 2}
          style={{
            bottom: '9%',
            right: '-25%',
          }}
        >
          margin-bottom: -75px
        </Label>
      </Layer>

      <Layer style={{ top: 75, zIndex: 2, ...firstSpring }}>
        <Skew>
          <NegativeTopMargin style={{ height: 25 }} />
          <BaseElement />
        </Skew>
        <Label
          orientation="up"
          isVisible={stepIndex === 2}
          style={{
            top: '-28%',
            left: '-25%',
          }}
        >
          margin-top: -25px
        </Label>
      </Layer>
    </Wrapper>
  );
}

const Wrapper = styled(BaseWrapper)`
  height: 360px;
`;

const ChildElement = styled(BaseElement)`
  background: rgba(255, 255, 255, 0.25);
`;

const NegativeMargin = styled(BaseMargin)`
  transform: translateY(-100%);
`;

const NegativeTopMargin = styled(BaseMargin)`
  transform: translateY(100%);
`;

export default Multi;
